import * as React from 'react';
export const TTSvg = React.forwardRef(function TTSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M16 4v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M16 8v4a2 2 0 0 1-2 2H9v-1h5a1 1 0 0 0 1-1V8h1ZM0 8V4a2 2 0 0 1 2-2h5v1H2a1 1 0 0 0-1 1v4H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 5V4a2 2 0 0 1 2-2h.5L16 11v1a2 2 0 0 1-2 2h-1L0 5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M13.997 2A2 2 0 0 1 16 4.01V9.5L4.5 2h9.497ZM0 11.99V6.5L11 14H1.992C.9 14 0 13.1 0 11.99Z',
      }),
    ),
  );
});
TTSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TT = {
  category: 'flag',
  colorable: false,
  name: 'TT',
  svg: TTSvg,
};
